export default "__VITE_ASSET__BQWClmVH__"